// extracted by mini-css-extract-plugin
module.exports = {"table":"TaskList_table__uEVTA"};